export default __webpack_public_path__ + "static/media/7.d2726ab3.jpg";